module.exports = __webpack_public_path__ + "img/circle2.91c7bf8e.png";